module.exports = __webpack_public_path__ + "static/media/avenir-next-bold.ebca6a67.ttf";